// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import './styles.scss'

type RailProps = {
  children?: React.Node,
  side: 'right' | 'left'
}

type WrapperProps = {
  side: 'right' | 'left',
  className?: string
}

/**
 * Wrap a component in a Semantic UI Rail.
 * @param children
 * @param side
 */
function Rail ({ children, side = 'right' }: RailProps): React.Element<'div'> {
  return <div className={`ui very close ${side} rail`}>{children}</div>
}

/**
 * Wrap a component in a Rail if the windows is large enough (i.e. 1200px wide)
 * @return {function(React.ComponentType<any>): function(*)}
 */
export const withRail = (Component: React.ComponentType<any>) => ({
  side,
  className
}: WrapperProps) => {
  // Set up the component
  let componentToWrap = <Component />

  if (window.matchMedia('(min-width: 1200px)').matches) {
    componentToWrap = <Rail side={side}>{componentToWrap}</Rail>
  }

  return (
    <aside
      className={`ui railed component very fitted basic ${className} segment`}
    >
      {componentToWrap}
    </aside>
  )
}
